import type { BaseTranslation } from '../i18n-types';

export const landings = {
    main: {
        title: `1-on-1 Random Video Chat {appName:string}`,
        subtitle: `{appName:string} is a video chat roulette where men are connected with real&nbsp;women worldwide. To start chatting choose who are you:`,
        buttonMaleLabel: 'I am man',
        buttonFemaleLabel: 'I am woman',
        buttonStartLabel: 'Start video chat',
        storiesHeader: 'Explore hot girls',
        storiesAction: 'See all',
        sec1: {
            title: `{appName:string} – meet people, have fun, and flirt online`,
            text: `{appName:string} is an anonymous video chat roulette where men only connect with real women. It is your go-to spot for exciting one-to-one random video calls with people from all over the world. Just hit the button, and you'll instantly connect with someone new. It's super easy, safe, and loads of fun. Turn on your camera and join the party – thousands of beautiful girls are waiting for you!`,
            imgAlt: 'Video chat with girls on {appName:string}',
        },
        sec2: {
            title: `What makes {appName:string} special`,
            intimate: {
                title: 'One-on-One Video Chat Experience',
                text: `Be prepared for personal and private attention during the chat. {appName:string} has no public streams, only 1-on-1, cozy communication. All of the other person's attention is focused on you, making communication really special, valuable, and exciting. You can relax and just be yourself, flirt, and have fun.`,
                imgAlt: 'Random video call with girl on {appName:string}',
            },
            exclusive: {
                title: 'Men only connect with women',
                text: `Unlike other random video chat roulettes, {appName:string} always matches you with someone of the opposite gender. Be sure to see a beautiful girl on the other side of the screen. Join now and immerse yourself in a fascinating experience. Beautiful girls are online and ready to chat.`,
                imgAlt: 'Video chat girls on {appName:string}',
            },
            seamless: {
                title: 'Automatic message translation',
                text: 'Communicating with people from other countries has never been easier. With our automatic translation tool, you can forget about language barriers and enjoy chatting. Focus on communicating and let us do the rest.',
                imgAlt: 'Video chat with women on {appName:string}',
            },
            private: {
                title: 'Anonymous Video Chat',
                text: `At {appName:string}, your safety and anonymity are our top priorities. We've created a safe space for you to connect with people from around the world. Our advanced algorithms guarantee stable connections while maintaining strict privacy standards. Communicate without fear of exposure.`,
                imgAlt: 'Anonymous Video Chat {appName:string}',
            },
        },
        sec3: {
            title: `How does {appName:string} work`,
            randomized: {
                title: 'Start searching',
                text: `Once you join the webcam chat and give permission for your video camera and microphone, {appName:string} will automatically pick a random opposite-sex chat partner.`,
                imgAlt: 'Find opposite-sex chat partner on {appName:string}',
            },
            engaging: {
                title: 'Find a match, chat, and flirt',
                text: 'After you connect with a stranger, you can have fun with your camera and microphone, or just type your messages into a chat. Relax and enjoy the conversation.',
                imgAlt: 'Flirt video chat on {appName:string}',
            },
            endless: {
                title: 'Choose the next stranger',
                text: 'You can have as many matches as you like. If the conversation gets boring or tense, hit the "Next" button and dive into a new adventure!',
                imgAlt: 'Flirt chat with strangers on {appName:string}',
            },
        },
        sec4: {
            title: `Join {appName:string} Now`,
            text: 'Over 1,000,000 users have already enjoyed us. We provide secure, anonymous, and fascinating free video chat with people from all over the world.',
            popular: {
                text: 'Users are already with us',
                imgAlt: 'Sex chat roulette on {appName:string}',
            },
            active: {
                text: 'Users online every day',
                imgAlt: 'Random sex chat on {appName:string}',
            },
            global: {
                text: 'Сountries are connected',
                imgAlt: 'Live video chat with girls on {appName:string}',
            },
            buttonLabel: 'TRY FOR FREE',
        },
        sec5: {
            title: 'FAQ',
            unmatched: {
                title: `Why is {appName:string} the best Omegle alternative?`,
                text: `{appName:string} is an anonymous video chat roulette where men always have a connection with women. Just hit the button and chat with people from all over the world. It’s the best choice if you like to have fun with strangers in a safe space.`,
            },
            freemium: {
                title: `Can I use {appName:string} for free?`,
                text: `Yes, you can try {appName:string} for free, but to get access to all the features you need to buy a membership.`,
            },
            anonymous: {
                title: `Is it safe to chat on {appName:string}?`,
                text: `Yes, it's absolutely safe. You will always have an anonymous one-to-one chat. Nobody will be able to find out anything about you unless you tell them yourself.`,
            },
            personalized: {
                title: 'Why do I have to specify my gender?',
                text: `At {appName:string} we only provide opposite sex matches. So in order to make the right match, we need to know who you are.`,
            },
            zeroTolerance: {
                title: 'What if I encounter inappropriate content?',
                text: `You need to report the user. We have no tolerance for any inappropriate content, hate speech, or bullying. We deal with every report and sec offenders.`,
            },
            spontaneous: {
                title: 'Can I handpick my chat partners?',
                text: `No, it's completely random chat roulette, where you never know which connection will be next.`,
            },
            versatile: {
                title: `From which device can I use {appName:string}?`,
                text: `{appName:string} is available on all devices such as laptops, smartphones, and tablets. Choose any convenient way and connect to a conversation with people from all over the world.`,
            },
        },
    },
    mainSafe: {
        metaTitle: '{appName:string}: Talk to Strangers & Enjoy Random Video Chat',
        metaDescription: 'Discover {appName:string}.com, the top platform for stranger chat and video calls. Talk to strangers, make new friends, and enjoy random video chats with ease. Experience the excitement of talking to strangers online, just like Omegle or OmeTV!',
        title: 'Talk to Strangers on {appName:string}',
        description: '{appName:string} – Meet and Chat Instantly! Connect with real people in a fun and easy way. Join now!',
        sec1: {
            title: '{appName:string} – talk with strangers, have fun and make new friends',
            text: 'Talk with strangers in a safe and exciting way. Forget the endless scrolling and messaging of traditional dating apps — on {appName:string}, you’re instantly connected through a random video chat with real people. Our user-friendly interface and variety of users will let you easily find your perfect match and enjoy a random video chat with strangers from all over the world who could become lifelong friends or meaningful connections.',
            imgAlt: 'Talk with stranger on {appName:string}',
        },
        sec2: {
            title: 'What makes {appName:string} special',
            serendipity: {
                title: 'Random and fun',
                text: 'A random video call with strangers offers the perfect balance of choice and surprise — you can skip a chat if the vibe isn’t right or embrace something unexpected to brighten your day. It connects you with special people you might never meet otherwise, making your life more vibrant and rich with new experiences.',
                imgAlt: 'Random video call with strangers on {appName:string}',
            },
            liberating: {
                title: 'Safe space to open up',
                text: 'Talking to total strangers might feel a bit intimidating at first, but there’s no need to worry. {appName:string} is an anonymous video chat platform that prioritizes your privacy. It’s a safe space where you can make friends, flirt and have fun without fear of judgment.',
                imgAlt: 'Anonymous video chat on {appName:string}',
            },
            convenience: {
                title: 'No need to go anywhere',
                text: 'Meet extraordinary and fascinating people from around the world without ever leaving your home. Through online video calls with strangers, you can connect with new faces, practice languages, share unique experiences, flirt and have fun — all from the comfort of your daily routine.',
                imgAlt: 'Online video call with strangers on {appName:string}',
            },
            unlikely: {
                title: 'Random path to meaningful connection',
                text: 'The older we get, the harder it can be to make new friends. With {appName:string}, you can connect through a video call with strangers, and if you feel a spark, you can add each other to your favorites. From there, you can continue chatting regularly through text or direct calls, building meaningful friendships and genuine emotional connections.',
                imgAlt: 'Stranger video call on {appName:string}',
            },
        },
        sec3: {
            title: 'How does {appName:string} work',
            exploration: {
                title: 'Start searching',
                text: 'Register on {appName:string}, select your gender, and dive into 1-on-1 video chats with strangers. With thousands of registered users, each bringing their own unique traits and interests, you’re bound to have an unforgettable experience.',
                imgAlt: '1 on 1 video chat with strangers on {appName:string}',
            },
            connection: {
                title: 'Find a match, chat, and flirt',
                text: 'When you chat with a stranger, share your interests, stay curious, and don’t forget to smile — it’s the key to making the conversation enjoyable for both sides. You can also flirt and send gifts to break the ice and create a connection.',
                imgAlt: 'Chat with stranger on {appName:string}',
            },
            discovery: {
                title: 'Choose the next stranger',
                text: 'You can skip other users until you find the one who feels just right —  and you’re not just video chat strangers anymore. Whether you’re looking for a friend, a great conversation, or even a soulmate, {appName:string} has you covered.',
                imgAlt: 'Video chat strangers on {appName:string}',
            },
        },
        sec4: {
            title: 'Join {appName:string} Now',
            text: 'Try {appName:string} today — the ultimate video chatroulette with strangers! Start connecting in just a few clicks, gain access to thousands of registered users from around the world, and enjoy a fantastic time filled with joy and excitement.',
            community: {
                text: 'Users are already with us',
                imgAlt: 'Video chatroulette with strangers on {appName:string}',
            },
            active: {
                text: 'Users online every day',
                imgAlt: 'Video chat on {appName:string}',
            },
            global: {
                text: 'Countries are connected',
                imgAlt: 'Random video chat with strangers on {appName:string}',
            },
            buttonLabel: 'TRY FOR FREE',
        },
        sec5: {
            title: 'FAQ',
            approachable: {
                title: 'How to talk to strangers',
                text: 'Be friendly and polite, don’t forget to smile, share your interests, and ask questions — and most importantly, don’t worry. On {appName:string}, you can be your true self, allowing your personality and all your qualities to shine.',
            },
            freemium: {
                title: `Can I use {appName:string} for free?`,
                text: `Yes, you can try {appName:string} for free, but to get access to all the features you need to buy a membership.`,
            },
            icebreaker: {
                title: 'How to start conversation with a stranger online',
                text: 'A great way to start a conversation is with a compliment. Notice something you like about the other person and let them know. You can also ask how they’re feeling, how their day went, or share something from your own experience to break the ice.',
            },
            anonymous: {
                title: 'Is it safe to chat on {appName:string}?',
                text: `Yes, it's absolutely safe. You will always have an anonymous one-to-one chat. Nobody will be able to find out anything about you unless you tell them yourself.`,
            },
            instantaneous: {
                title: 'How to meet strangers online',
                text: `There are plenty of apps and websites to meet strangers, but we offer a fun and effortless way to connect. With instant live video chats, you can see and interact with real people right away — no endless texting required.`,
            },
            respectful: {
                title: 'How to chat with strangers online',
                text: 'Stay positive, don’t be afraid to show your true emotions, and always be considerate of other people’s feelings. However, remember to protect your privacy — avoid sharing personal details like your home address or bank account information.',
            },
            spontaneous: {
                title: 'Can I handpick my chat partners?',
                text: `No, it's completely random chat roulette, where you never know which connection will be next.`,
            },
            versatile: {
                title: 'From which device can I use {appName:string}?',
                text: '{appName:string} is available on all devices such as laptops, smartphones, and tablets. Choose any convenient way and connect to a conversation with people from all over the world.',
            },
        },
    },
} satisfies BaseTranslation;
